import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SettingsNav } from "@/components/settings/settings-nav";

export const Route = createFileRoute("/_workspace/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <div className="mx-auto flex w-full max-w-6xl flex-1 flex-col gap-8 px-6 py-8 md:py-12">
      <header className="flex flex-col gap-1">
        <h1 className="font-heading text-3xl font-semibold tracking-tight">Settings</h1>
        <p className="text-sm text-muted-foreground">
          Manage your profile, company, and HR Docket preferences.
        </p>
      </header>
      <div className="grid flex-1 grid-cols-1 gap-8 md:grid-cols-[200px_1fr] lg:grid-cols-[220px_1fr]">
        <aside className="md:sticky md:top-20 md:self-start">
          <SettingsNav />
        </aside>
        <main className="min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
